// Shared route loader: extracts the encrypted/encoded order data from the URL.
// Used by every customer route regardless of platform.
export function orderLoader({ params }) {
  return params.order;
}
